import VacationIcon from "@mui/icons-material/BeachAccess";
import { useTimeAccounts } from "~api/timeAccounts.ts";
import { useFeatureGate } from "~api/useFeatureGate.ts";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import { LegacyVacationEntitlementCard } from "../SlideableTimeWidget/LegacyVacationEntitlementCard";
import { VacationEntitlementCard } from "../SlideableTimeWidget/VacationEntitlementCard";

export function VacationEntitlementWidget() {
  const t = useTranslation();
  const { data } = useTimeAccounts();
  const { enabled, settled } = useFeatureGate(
    "vacation_and_leisure_time_account",
  );
  const vacationEntitlement = data?.vacation_entitlement ?? null;

  if (vacationEntitlement == null || !settled) {
    return null;
  }

  return (
    <div>
      <h2>{t.myTimeEntries}</h2>
      {enabled ? (
        <VacationEntitlementCard vacation={vacationEntitlement} />
      ) : (
        <LegacyVacationEntitlementCard
          vacation={vacationEntitlement}
          icon={VacationIcon}
        />
      )}
    </div>
  );
}
